import * as React from "react";
import { ContentProps } from "components/flexComponents/Content/typings";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";

const CONTENT_ID_COUNT = 3;
export const CardComparisonBenefitsSectionEditorial = (props: ContentProps) => {
  const flexComponent = props.flexComponent;
  const model = flexComponent && flexComponent.model;
  const items = (model && model.items && model.items.filter((item) => item)) || [];

  if (!model || items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [benefitsIcon, benefitsTitle, benefitsDescription] = React.useMemo(
    () => items.map((item) => decorateEditorialHtml(item.text)),
    []
  );

  return (
    <div className="xl-l-padding-twelve l-l-padding-twelve m-x-padding-twelve xl-l-margin-six l-l-margin-six m-x-margin-twelve">
      <UitkLayoutFlex space="three">
        <UitkLayoutFlexItem>
          <div dangerouslySetInnerHTML={benefitsIcon} />
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <div>
            <UitkText size={400} weight="bold">
              <div dangerouslySetInnerHTML={benefitsTitle} />
            </UitkText>
            <UitkText size={200}>
              <div dangerouslySetInnerHTML={benefitsDescription} />
            </UitkText>
          </div>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </div>
  );
};

export default CardComparisonBenefitsSectionEditorial;
